module.exports = __webpack_public_path__ + "media/brands/neptun-36ffe5b7.png";